var React = require('react');

function Logo (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M17.5237 0H15.4734H1.53094C0.656117 0 0 0.656117 0 1.53094V15.364V17.4691C0 18.3439 0.656117 19 1.53094 19H3.5813H17.5237C18.3712 19 19.0547 18.3439 19.0547 17.4691V3.63597V1.53094C19.0547 0.656117 18.3986 0 17.5237 0Z","fill":"#CC4E41","key":0}),React.createElement("path",{"d":"M3.88053 9.76021L6.96974 10.8537V12.3847L2.29492 10.4163V9.13143L6.96974 7.16309V8.69401L3.88053 9.76021Z","fill":"white","key":1}),React.createElement("path",{"d":"M8.74586 13.7785H7.59766L10.4955 5.22168H11.671L8.74586 13.7785Z","fill":"white","key":2}),React.createElement("path",{"d":"M15.1439 9.76021L12 8.66668V7.16309L16.7022 9.13143V10.4163L12 12.3847V10.8811L15.1439 9.76021Z","fill":"white","key":3})]);
}

Logo.defaultProps = {"width":"20","height":"19","viewBox":"0 0 20 19","fill":"none"};

module.exports = Logo;

Logo.default = Logo;
